// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__kELtb","head":"Table_head__znxmF","col":"Table_col__2ABJO"};